import * as React from "react";
const SvgFiRrBadgeDollar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-badge-dollar_svg__a)">
      <path
        fill="#062147"
        d="M24 12c0-1.626-.714-3.16-1.925-4.124a5.49 5.49 0 0 0-1.59-4.362c-1.15-1.149-2.734-1.731-4.277-1.555A5.49 5.49 0 0 0 12 0c-1.626 0-3.16.714-4.124 1.925a5.48 5.48 0 0 0-4.362 1.59c-1.15 1.15-1.729 2.74-1.555 4.277A5.49 5.49 0 0 0 0 12c0 1.626.714 3.16 1.925 4.124a5.49 5.49 0 0 0 1.59 4.362c1.15 1.151 2.744 1.732 4.277 1.555A5.49 5.49 0 0 0 12 24c1.626 0 3.16-.714 4.124-1.925a5.5 5.5 0 0 0 4.361-1.59c1.149-1.15 1.729-2.74 1.555-4.277A5.49 5.49 0 0 0 24 12m-3.247 2.678a1.88 1.88 0 0 0-.67 1.617 3.498 3.498 0 0 1-3.788 3.788 1.88 1.88 0 0 0-1.616.67A3.5 3.5 0 0 1 12 22.001a3.5 3.5 0 0 1-2.679-1.248 1.88 1.88 0 0 0-1.616-.669 3.5 3.5 0 0 1-3.787-3.788 1.88 1.88 0 0 0-.67-1.617 3.497 3.497 0 0 1 0-5.357c.479-.404.723-.993.669-1.617a3.497 3.497 0 0 1 3.788-3.787 1.9 1.9 0 0 0 1.617-.67 3.497 3.497 0 0 1 5.357 0 1.87 1.87 0 0 0 1.617.669 3.499 3.499 0 0 1 3.787 3.788c-.054.624.19 1.213.67 1.617a3.496 3.496 0 0 1 0 5.356M16 14c0 1.654-1.346 3-3 3v1a1 1 0 0 1-2 0v-1h-.268a3.01 3.01 0 0 1-2.598-1.499A1 1 0 0 1 9.865 14.5c.178.308.511.5.867.5H13c.552 0 1-.449 1-1a.77.77 0 0 0-.644-.76l-3.042-.507A2.76 2.76 0 0 1 7.999 10c0-1.654 1.346-3 3-3V6a1 1 0 0 1 2 0v1h.268c1.067 0 2.063.575 2.598 1.5a1 1 0 1 1-1.73 1.001 1 1 0 0 0-.867-.5H11c-.551 0-1 .449-1 1 0 .378.271.698.644.76l3.041.507A2.76 2.76 0 0 1 16 14.001z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-badge-dollar_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBadgeDollar;
